interface IRowProps {
  style?: any;
  content?: string | number | JSX.Element;
  className?: string;
}

export default function CellsRow({style, content, className}: IRowProps) {
  return (
    <td style={style ? style : {}} className={className ? className : ""}>
      {content}
    </td>
  )
}